import PropTypes from "prop-types";
import React from "react";

import { inputPropTypes } from "@swa-ui/core";
import { TextFormField } from "@swa-ui/form";
import i18n from "@swa-ui/locale";

import { MIDDLE_NAME_SCHEMA_FIELD_NAME } from "./MiddleNameFormField.schema";

/**
 * MiddleNameFormField facilitates the input of a middle name.
 */

export const MiddleNameFormField = (props) => {
  const { componentProps, description, disabled, name = MIDDLE_NAME_SCHEMA_FIELD_NAME } = props;

  return <TextFormField {...getTextFormFieldProps()} />;

  function getTextFormFieldProps() {
    return {
      componentProps: {
        "aria-label": i18n("MiddleNameFormField__ARIA"),
        ...componentProps,
      },
      description,
      disabled,
      label: i18n("MiddleNameFormField__LABEL"),
      name,
    };
  }
};

export const middleNameFormFieldPropTypes = {
  /** Component props for input component. */
  componentProps: PropTypes.shape(inputPropTypes),

  /** Indicates whether the field is disabled. */
  disabled: PropTypes.bool,

  /** Form field name used in schema validation and service call payload. */
  name: PropTypes.string,
};

MiddleNameFormField.propTypes = middleNameFormFieldPropTypes;
